<template>
    <div class="platform">
        <div class="title">
            <div>Platforms</div>
            <div>旗下平台</div>
        </div>
        <div class="platformContent">
            <div v-for="(item, index) in list" :key="index" ref="platformContentLi" @mouseenter="handleMouseEnter(index)"
                @mouseleave="handleMouseLeave(index)">
                <img :src="listIndex == index ? item.src1 : listIndex == -1 ? item.src : item.src2" alt="">
                <div class="platformContentText" v-if="listIndex == index" v-html="item.text">
                </div>
                <div class="platformContentTitle"
                    :class="listIndex == -1 || listIndex == index ? '' : 'platformContentTitle1'">
                    <span>{{ item.title }}</span>
                </div>
                <div class="more" v-show="listIndex == index" @click="goIndex(index)" style="cursor: pointer;">
                    <div>更多<img src="../assets/img/Slice11.png" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    title: '线上商城--匠油网',
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img1.png',
                    src1: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img1.2_hover.png',
                    src2: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img1.3.png',
                    text: '“匠油网”平台是厦门油典集团有限公司自主研发的B2B电商平台，致力于提供一流的在线购物体验，满足现代电子商务时代的需求。该平台的核心理念是让客户能够随时随地通过手机轻松浏览商品、下单采购、及时掌握产品优惠动态（根据账号授权区分经销价和市场指导价）。平台还支持产品分销，为同行伙伴和渠道经销商提供技术支持，帮助他们开设线上店铺，共享海量客户资源、产品资源，实现线上线下业务完美结合。'
                },
                {
                    title: '代理商平台--油匠网',
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img2.png',
                    src1: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img2.3_hover.png',
                    src2: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img2.2.png',
                    text: '<div style="font-size:32px;margin-bottom:11px;line-height:51.2px;font-weight: bold;">自研的代理商系统平台 定制专用</div>专为油典集团代理商打造的一键式分享平台，自购和分享给他人下单购买均可获得收益。 产品售后及服务环节，由公司内部客服团队组成“服务团队”统一维护。（此平台只针对渠道经销商使用，不对终端用户开放）'
                },
                {
                    title: '采购平台--炬诚润滑',
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img3.png',
                    src1: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img3.3_hover.png',
                    src2: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/pingtai_img3.2.png',
                    text: '<div style="font-size:32px;margin-bottom:11px;line-height:51.2px;font-weight: bold;">采购云系统平台 炬诚润滑</div>油典集团采购云系统，专为供应商报价提供方便。我们发布采购需求后，供应商可在手机端收到报价提示，直接点击进行报价后即可，节省询价沟通的时间，提升效率，后台自动进行数据分析，匹配筛选合适的供应商进行下单合作'
                }
            ],
            listIndex: -1,
        }
    },
    methods: {
        handleMouseEnter(e) {
            this.$refs.platformContentLi[e].style.flex = '4'
            this.listIndex = e
        },
        handleMouseLeave(e) {
            this.$refs.platformContentLi[e].style.flex = '1'
            this.listIndex = -1
        },
        goIndex(index){
            this.$router.push('/Products?index='+index)
        },
    },
}
</script>
<style scoped>
.platform {
    /* height: 1283px; */
    width: 100%;
    background: #fff;
}

.title {
    padding: 196px 0 0 189px;
}

.title>div:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 70px;
    color: #373737;
    line-height: 82px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    position: relative;
}

.title>div:last-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 44px;
    color: #373737;
    line-height: 52px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.title>div::before {
    position: absolute;
    display: inline-block;
    content: ' ';
    width: 11px;
    height: 121px;
    background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
    border-radius: 0px 0px 0px 0px;
    top: 10px;
    left: -39px;
}

.platformContent {
    width: 80%;
    display: flex;
    margin-top: 39px;
    height: 600px;
    margin-left: 10%;
}

.platformContent>div {
    flex: 1;
    position: relative;
}

.platformContent>div>img {
    width: 100%;
    height: 100%;
}

.platformContentTitle {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 26px;
    color: #FFFFFF;
    line-height: 38px;
    font-style: normal;
    text-transform: none;
    text-align: center;
    /* min-width: 348px; */
    white-space: normal;
    width: 100%;
}

.platformContentTitle>span {
    display: inline-block;
    padding: 24px 42px;
    border-radius: 0px 0px 0px 0px;
    border: 2px solid #FFFFFF;
}

.platformContentText {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 51px;
    letter-spacing: 4px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.platformContentTitle1>span {
    display: inline-block;
    padding: 24px 0;
    border-radius: 0px 0px 0px 0px;
    border: none;
    border-bottom: 2px solid #FFFFFF;
}

.more {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 196px;
    height: 67px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 67px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    background: #45AFFF;
    text-align: center;
}

.more img {
    width: 35px;
    height: 35px;
    display: inline-block;
}</style>



// WEBPACK FOOTER //
// src/components/platform.vue